import { createContext, useContext } from 'react';

/**
 * True while a guide is being rendered on the public mirror at /kb.
 *
 * Screen links are suppressed there for everyone, not merely for readers who lack the permission.
 * Leaving it to permissions alone would make the page a different page depending on who opened the
 * link — a staff member checking the link they are about to send would see buttons the recipient
 * never gets, and would have no way to tell. The mirror shows one thing to everybody.
 */
export const PublicViewContext = createContext(false);

export const useIsPublicView = (): boolean => useContext(PublicViewContext);
